module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_2-c62414f8de5cd5534c3ea2c91918647b.jpg";